<template>
  <div class="myhome-profile__modify">
    <div class="myhome-profile__modify-header">
      <div class="myhome-profile__modify-header-title dea-heading--medium-m">{{ title }}</div>
      <Links
        v-if="showLink"
        class="myhome-profile__modify-header-link dea-links--large"
        :class="`dea-links--${linkColor}`"
        @click="$emit('open-modify')"
      >
        Modifica
      </Links>
    </div>
    <template v-if="options.length">
      <div v-for="(option, index) in options" :key="index" class="myhome-privacy__content dea-heading--regular-s">
        {{ option.compact }}
      </div>
    </template>
    <template v-else>
      <div class="myhome-privacy__content dea-heading--regular-s">
        {{ emptyLabel }}
      </div>
    </template>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";

export default {
  name: "MyProfileModify",
  components: { Links },
  props: {
    emptyLabel: {
      type: String,
      default: "Solo notifiche necessarie",
    },
    linkColor: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    showLink: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-profile__modify {
  margin: $space-large 0;

  &-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: $space-base;

    &-link {
      cursor: pointer;
    }
  }
}
</style>
